/**
 * A small deterministic (non-crypto) 32-bit string hash — Java's `hashCode`. Its values
 * are persisted (draft keys) and seen (avatar colors), so the formula must not change.
 */
export const stableHash = (seed: string): number => {
  let hash = 0
  for (let i = 0; i < seed.length; i++) {
    hash = (hash * 31 + seed.charCodeAt(i)) | 0
  }
  return hash
}
